const getCookieName = (name) => `${name}-${process.env.REACT_APP_ENV}`

export const SUPER_ADMIN = "superadmin";
export const ADMIN = "admin";
export const ADD_NEW = "add_new";
export const RECORD_EXIST = "record_exist";
export const INDUSTRY = "Industry";
export const LEAD_SOURCE = "Source";
export const LEAD_STATUS = "Status";
export const COMPANY_SIZE = "Company Size";
export const PAYMENT_MODE = "Payment Mode";
export const STAGE = "Stage";
export const TYPE = "Type";
export const SCORE = "Score";
export const EMAIL_SENT = "sent";
export const EMAIL_SENDING = "sending";
export const EMAIL_DRAFT = "draft";
export const EMAIL_CANCELLED = "cancelled";
export const EMAIL_SCHEDULED = "scheduled";
export const LEAD = "lead";
export const PIPELINE = "pipeline";
export const POTENTIAL = "potential";
export const DEAL = "deal";
export const LOST_LEAD = "lost_lead";
export const LOST_LEAD_REVERSE = "lead_lost";
export const LAST_SIX_MONTHS = "last_6_months";
export const THIS_MONTH = "this_month";
export const THIS_WEEK = "this_week";
// constants for create campaign modules
export const LEADS = "Leads";
export const POTENTIALS = "Potentials";
export const PIPELINES = "Pipelines";
export const DEALS = "Deals";
export const LOST = "lost-lead";
export const LOST_LEADS = "Lost leads";
export const LOST_LEADS_CAPITALIZE = "Lost Leads";
export const PROFILE_PREFERENCE = "Profile Preferences"
export const FREE = "Free";
export const GET_STARTED_FREE = "Get started free";
export const ALREADY_IN_USE = "Already in use";
export const BUY_NOW = "Buy now"
export const EXECUTIVE = "executive";
export const INVITE_VIA_EMAIL = "invite_via_email";
export const DELETE = "delete";
export const IS_ARCHIVE = "is_archived";
export const IS_DRAFT = "draft";
export const IS_CANCEL = "cancel";
export const CAMPAIGN_EMAIL = "email_campaign";
export const CAMPAIGN_ARCHIVE = "archive_campaign";
export const EVERY_ONE = "everyone";
export const SAVE_IN_DRAFT = "save_in_draft";

// cookie
export const USER_COOKIE = getCookieName("user-session");
export const GUEST_INFO = getCookieName("guest-info");

// master admin
export const MASTER_ADMIN = "master-admin";

// env
export const HOST_DOMAIN = process.env.REACT_APP_HOST_DOMAIN;
export const HOST_URL = process.env.REACT_APP_HOST_URL;

// error messages
export const FORM_TYPE_NOT_FOUND = 'Something went wrong! Form-type is not found thus, can not process this action.';
export const SELECT_ATLEAST_ONE = "Please select atleast one entry to proceed!";
export const INVALID_ID_DATA = "Cannot process this action due to invalid data";
export const INTERNAL_ERROR = "Internal Server Error";
export const UNAUTHORISED_ERROR = "Session expired. Please Login Again!";
export const NETWORK_ERROR = "There is a problem in connecting with server, Please check your internet connection or try again later";
export const NO_DATA_FOUND = "An error occurred while fetching data!";
export const UPLOAD_ERROR = "Please upload all values in columns of excel file";
export const INVALID_DATA = "Id not Found";
export const CAN_NOT_BE_EMPTY = 'can not be empty';
export const ENTER_VALID = 'Please enter a valid';
